import React from "react";

export default function PatientIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9999 13.3335C11.9999 12.2726 11.5785 11.2552 10.8283 10.5051C10.0782 9.75492 9.06078 9.3335 7.99992 9.3335M7.99992 9.3335C6.93905 9.3335 5.92164 9.75492 5.17149 10.5051C4.42135 11.2552 3.99992 12.2726 3.99992 13.3335M7.99992 9.3335C9.47268 9.3335 10.6666 8.13959 10.6666 6.66683C10.6666 5.19407 9.47268 4.00016 7.99992 4.00016C6.52716 4.00016 5.33325 5.19407 5.33325 6.66683C5.33325 8.13959 6.52716 9.3335 7.99992 9.3335ZM14.6666 8.00016C14.6666 11.6821 11.6818 14.6668 7.99992 14.6668C4.31802 14.6668 1.33325 11.6821 1.33325 8.00016C1.33325 4.31826 4.31802 1.3335 7.99992 1.3335C11.6818 1.3335 14.6666 4.31826 14.6666 8.00016Z"
        stroke="#14B8A6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
